import { startAutoUpdate } from '@khaddi/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

// react-native-web's vendored Animated calls `global.cancelAnimationFrame` when an animation is interrupted.
Object.assign(globalThis, { global: globalThis });

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');
createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// no service worker in dev: it would cache Vite's unbundled modules
if (import.meta.env.PROD) startAutoUpdate();
